import { useState } from "react";
import { ClipboardList, Check, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

export const ChecklistCapture = () => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/leads/checklist", { email, source: "home_checklist" });
      setDone(true);
    } catch (err) {
      toast.error(formatApiError(err?.response?.data?.detail));
    }
    setBusy(false);
  };

  return (
    <section data-testid="checklist-capture" className="mx-auto max-w-7xl px-6 py-16">
      <div className="rounded-3xl bg-charcoal-800 px-8 py-12 sm:px-14 sm:py-14">
        <div className="flex flex-col items-start gap-8 lg:flex-row lg:items-center lg:justify-between">
          <div className="max-w-xl">
            <p className="inline-flex items-center gap-2 text-sm font-medium uppercase tracking-wide text-terracotta">
              <ClipboardList size={16} /> Free download
            </p>
            <h2 className="mt-3 font-serif text-3xl text-white sm:text-4xl">Get the free US → Mexico moving checklist</h2>
            <p className="mt-3 text-base text-white/70">The 10 steps every smooth move follows — from paperwork to pets — straight to your inbox.</p>
          </div>
          {done ? (
            <p data-testid="checklist-success" className="inline-flex items-center gap-2 rounded-full bg-white/10 px-6 py-3 text-sm font-medium text-white">
              <Check size={16} className="text-sage" /> Sent! Check your inbox.
            </p>
          ) : (
            <form onSubmit={submit} className="flex w-full max-w-md flex-col gap-3 sm:flex-row">
              <input data-testid="checklist-email" type="email" required placeholder="Your email" value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full rounded-full border border-white/20 bg-white/10 px-5 py-3 text-white placeholder:text-white/50 focus:outline-none focus:ring-2 focus:ring-terracotta/60" />
              <button data-testid="checklist-submit" type="submit" disabled={busy}
                className="inline-flex shrink-0 items-center justify-center gap-2 rounded-full bg-terracotta px-6 py-3 font-medium text-white hover:bg-terracotta-hover disabled:opacity-60">
                {busy ? <Loader2 size={16} className="animate-spin" /> : null} Send it to me
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
};
